"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetType1ToJSON = exports.AssetType1FromJSONTyped = exports.AssetType1FromJSON = exports.AssetType1 = void 0;
/**
 *
 * @export
 */
exports.AssetType1 = {
    Image: 'IMAGE',
    Audio: 'AUDIO',
    Video: 'VIDEO',
    Uri: 'URI',
    Survey: 'SURVEY'
};
function AssetType1FromJSON(json) {
    return AssetType1FromJSONTyped(json, false);
}
exports.AssetType1FromJSON = AssetType1FromJSON;
function AssetType1FromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AssetType1FromJSONTyped = AssetType1FromJSONTyped;
function AssetType1ToJSON(value) {
    return value;
}
exports.AssetType1ToJSON = AssetType1ToJSON;
